import React, { Component, useEffect, useState } from "react";
import { Layout } from "antd";

import Sidebar from "../Sidebar/index";
import HorizontalDefault from "../Topbar/HorizontalDefault/index";
import HorizontalDark from "../Topbar/HorizontalDark/index";
import InsideHeader from "../Topbar/InsideHeader/index";
import AboveHeader from "../Topbar/AboveHeader/index";
import BelowHeader from "../Topbar/BelowHeader/index";
import Topbar from "../Topbar/index";
import { footerText } from "util/config";
import App from "routes/index";
import { connect } from "react-redux";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from "../../constants/ThemeSetting";
import NoHeaderNotification from "../Topbar/NoHeaderNotification/index";
// import Customizer from "containers/Customizer";
import { APP_MESSAGE_BROADCAST_CHANNEL, AUTHORIZED_ROLES, REFRESH_TOKEN_INTERVAL_IN_MILLISECONDS } from "../../constants/constants";
import ErrorPage from "../../components/ErrorPages/ErrorPage";
import { userSignOut } from "../../appRedux/actions";
import { authRefresh, changePassword, NEW_SESSION_CREATED, resetReduxStore } from "../../appRedux/actions/Auth";
import SessionIdleTimer from "../../util/SessionIdleTimer/sessionIdleTimer";
import ChangePasswordModal from "../Admin/ChangePasswordModal";
import { showModal, hideModal, submitStart } from "../../appRedux/actions/userModalActions";
import { bindActionCreators } from "redux";
import { fetchIntegrator } from "../../appRedux/actions/integratorActions";
import { history } from "../../appRedux/store";
import { AugnitoBot } from "../../components/AugnitoSDK/AugnitoBot";
import { QuillrSessionHost } from './QuillrSessionHost';

const { Content, Footer } = Layout;

const MainApp = ({ match, width, navStyle, role, userSignOut, authRefresh, loadIntegrator,resetReduxStore,  ...props }) => {
  const userRole = role.replace("ROLE_", "");
  const isAuthorizedRole = AUTHORIZED_ROLES.includes(userRole);
  const grantedRoute = userRole.toLowerCase();
  const [state, setState] = useState({ loading: false, formData: { currentPassword: '', newPassword: '', confirmNewPassword: '' }, selectedStatus: null, dates: [], visitsReport: [], isExportLoading: false, isAllSiteSelected: false, isVisitReload: false });

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    }
  })

  useEffect(() => {
    const channel = new BroadcastChannel(APP_MESSAGE_BROADCAST_CHANNEL);
    channel.addEventListener("message", handleMessageEvent);
    return () => {
      channel.removeEventListener('message', handleMessageEvent);
    }
  },[])

  useEffect(() => {
    loadIntegrator();
    const authRefreshInterval = setInterval(async () => {
      await authRefresh(false);
    }, REFRESH_TOKEN_INTERVAL_IN_MILLISECONDS);
    return () => {
      clearInterval(authRefreshInterval);
    }
  }, []);

  const handleMessageEvent = (e) => {
    const { action , payload } = e.data;
    const activeSessionId = sessionStorage.getItem("USESSIONID");
    if(action == NEW_SESSION_CREATED && activeSessionId !== payload.sessionId){
      sessionStorage.removeItem('USESSIONID');
      resetReduxStore();
    }
  }

  const handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = "";
  }

  const handleUnload = (e) => {
    this.props.userSignOut();
  }

  const getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-container-wrap";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-container-wrap";
      default:
        return ""
    }
  };
  const getNavStyles = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />;
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />;
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />;
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />;
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />;
      case NAV_STYLE_FIXED:
        return <Topbar />;
      case NAV_STYLE_DRAWER:
        return <Topbar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };

  const getSidebar = (navStyle, width) => {
    if (width < TAB_SIZE) {
      return <Sidebar />;
    }
    switch (navStyle) {
      case NAV_STYLE_FIXED:
        return <Sidebar />;
      case NAV_STYLE_DRAWER:
        return <Sidebar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar />;
      default:
        return null;
    }
  };

  if (!isAuthorizedRole) {
    return <ErrorPage
      errorCode={403}
      errorAction="Logout"
      handleAction={() => userSignOut()}
    />
  }

  const { authUser, modal } = props;
  const { visible, submitting, type, data } = modal;
  const { changePasswordAtLogon } = authUser;

  const handleOk = (user) => {

    if (!state.loading) {
      setState({ ...state, loading: true })
      let userData = {
        ...user,
        currentPassword: window.btoa(user.currentPassword),
        newPassword: window.btoa(user.newPassword)
      }
      props.changePassword(userData);
      setTimeout(() => {
        setState({ ...state, loading: false });
      }, 3000);
    }
  }

  const handleClose = () => {
    props.hideModal();
  }
  const handleOpen = (user) => {
    props.showModal('ADD', user);
  }
  return (
    <Layout className="gx-app-layout">
      {getSidebar(navStyle, width)}
      <Layout>
        {getNavStyles(navStyle)}
        <Content className={`gx-layout-content ${getContainerClass(navStyle)} `}>
            {authUser.isScribeUser === true && authUser.authenticated && authUser.otpVerified === true ?
              <QuillrSessionHost key={authUser.userId}>
                <App match={match} grantedRoute={grantedRoute} />
              </QuillrSessionHost> : <App match={match} grantedRoute={grantedRoute} />}

          <AugnitoBot userTag={authUser.email}/>
          <SessionIdleTimer userSignOut={userSignOut} />
          {
            (changePasswordAtLogon) ?
              <ChangePasswordModal
                email={authUser.email}
                visible={changePasswordAtLogon}
                // visible={visible}
                submitting={submitting}
                onOk={handleOk}
                formData={state.formData}
                onCancel={handleClose}
                changePasswordAtLogon={changePasswordAtLogon}
                userSignOut={() => userSignOut()}
              />
              : <React.Fragment />
          }
          <Footer>
            <div className="gx-layout-footer-content">
              {footerText}
            </div>
          </Footer>
        </Content>
      </Layout>
      {/* <Customizer /> */}
    </Layout>
  )
}

export const mapDispatchToProps = dispatch => ({

  changePassword: bindActionCreators(changePassword, dispatch),
  showModal: bindActionCreators(showModal, dispatch),
  hideModal: bindActionCreators(hideModal, dispatch),
  submitStart: bindActionCreators(submitStart, dispatch),
  userSignOut: bindActionCreators(userSignOut, dispatch),
  authRefresh: bindActionCreators(authRefresh, dispatch),
  loadIntegrator: bindActionCreators(fetchIntegrator, dispatch),
  resetReduxStore: bindActionCreators(resetReduxStore, dispatch)
});

const mapStateToProps = ({ settings, auth, modal }) => {
  const { width, navStyle } = settings;

  return {
    width: width,
    navStyle: navStyle,
    authUser: auth ? auth.authUser : null,
    modal: modal,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MainApp);


